import React from "react";
import { capitalize } from "../../services/Utils";
import { DateAndTimeGridCell } from "../common/DateAndTimeGridCell";
import ConfigurationStatus from "./ConfigurationStatus";
import PublishConfiguration from "./PublishConfiguration";
import { getGridStringOperators } from "@mui/x-data-grid";

const getColumnsData = () => {
  return [
    {
      field: "configName",
      headerName: "Configuration Name",
      flex: 2,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value !== 'isEmpty' && operator.value !== 'isNotEmpty'
      ),
      editable: false,
    },
    {
      field: "vehicleNos",
      headerName: "Vehicle Nos",
      flex: 0.75,
      editable: false,
      disableColumnMenu: true,
    },
    {
      field: "createdBy",
      headerName: "Created by",
      sortable: true,
      flex: 0.75,
      valueFormatter: ({ value }) => capitalize(value),
    },
    {
      field: "campaignCreationDate",
      headerName: "Created On",
      sortable: true,
      flex: 0.75,
      type: "dateTime",
      renderCell: (data) => <DateAndTimeGridCell {...data} />,
    },
    {
      field: "configStatus",
      headerName: "Status",
      flex: 0.75,
      headerAlign: "center",
      align: "center",
      editable: false,
      type: "singleSelect",
      sortable: false,
      valueOptions: [
        { value: "COMPLETED", label: "Completed" },
        { value: "PUBLISHED", label: "Published" },
        { value: "SCHEDULED", label: "Scheduled" },
        { value: "NOT_PUBLISHED", label: "Not Published" },
        { value: "EXPIRED", label: "Expired" },
        { value: "CANCELED", label: "Canceled" },
      ],
      renderCell: (data) => {
        return <ConfigurationStatus status={data.row.configStatus} />;
      },
    },
    {
      field: "empty",
      headerName: "Actions",
      flex: 1,
      editable: false,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (data) => {
        return <PublishConfiguration data={data} />;
      },
    },
  ];
};

export { getColumnsData };
